module.exports = __webpack_public_path__ + "static/media/nav-icon-billing.235bdea5.svg";